export default __webpack_public_path__ + "static/NotoSansThai-Bold.subset-8fea18addefe31a18247a720ed453131.otf";